export const VIEW_CHANGE_PAGE = "VIEW_CHANGE_PAGE";
export const VIEW_CHANGE_TYPE = "VIEW_CHANGE_TYPE";
export const VIEW_CHANGE_CARD = "VIEW_CHANGE_CARD";

export const EXPORT_ERROR_ADD = "EXPORT_ERROR_ADD";
export const EXPORT_ERROR_RESET = "EXPORT_ERROR_RESET";
